// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../node_modules/rescript/lib/es6/array.js";
import * as React from "react";
import * as LockedCardInfo from "./LockedCardInfo.bs.js";
import * as ScoreMessageBox from "../common/ScoreMessageBox.bs.js";
import * as LockedScoreSlider from "./LockedScoreSlider.bs.js";

function LockedCardContentCmp(Props) {
  var locked_score_msg = Props.locked_score_msg;
  var thresholds = Props.thresholds;
  var message_text = Props.message_text;
  var message_box = Props.message_box;
  return React.createElement("div", {
              className: "locked-card-content-container"
            }, React.createElement(LockedCardInfo.make, {
                  locked_msg: locked_score_msg
                }), React.createElement(LockedScoreSlider.make, {
                  threshold_values: $$Array.of_list(thresholds)
                }), React.createElement(ScoreMessageBox.make, {
                  message_text: message_text,
                  message_box: message_box
                }));
}

var make = LockedCardContentCmp;

export {
  make ,
  
}
/* react Not a pure module */
